import { BaseDriver } from '@wix/wix-ui-test-utils/driver-factory';
import { HeadingAppearance, Size } from './index';

export interface HeadingDriver extends BaseDriver {
  getAppearance: () => HeadingAppearance | null;
  getSize: () => Size | null;
  getTagName: () => keyof HTMLElementTagNameMap;
  getText: () => string;
  isLight: () => boolean;
  isMasked: () => boolean;
  getId: () => string;
}
